export default class Widget {
    public id: string;
    public color: string;
    public displayName: string;

    constructor(public type: string, public settings: Object) { 
        let time = new Date().getTime();
        this.id = `${type}-${time}`;
    }
}


// WEBPACK FOOTER //
// ./src/store/models/Widget.ts